import React, { useEffect } from "react";
import { Container } from "reactstrap";
import ListTable from "./ListTable";
import { useDispatch } from "react-redux";
import { fetchRegisters } from "../../ReduxToolkit/Reducers/AppReducer";

export default function Registers() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchRegisters());
  }, []);

  return (
    <div className="page-body">
      <Container fluid className="p-0">
        <ListTable />
      </Container>
    </div>
  );
}
